import { render, staticRenderFns } from "./news-error.vue?vue&type=template&id=b36c89c6&"
import script from "./news-error.vue?vue&type=script&lang=js&"
export * from "./news-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b36c89c6', component.options)
    } else {
      api.reload('b36c89c6', component.options)
    }
    module.hot.accept("./news-error.vue?vue&type=template&id=b36c89c6&", function () {
      api.rerender('b36c89c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/news/news-error.vue"
export default component.exports